import { endOfWeek, format, formatISO, startOfWeek } from 'date-fns'
import { useEffect, useState, type ReactNode } from 'react'

import PageLoader from '@/compoments/PageLoader'
import { useGetDashboardQuery } from '@/services/executives/executives'
import type { ExecutivesDashboardQueryParams } from '@/services/executives/response.interface'

import Charts from './parts/Charts'
import JobStatistics from './parts/JobStatistics'

const startDate = formatISO(startOfWeek(new Date()))
const endDate = formatISO(endOfWeek(new Date()))

const ExecutivesDashboardPage = () => {
    const [queryParams, setQueryParams] =
        useState<ExecutivesDashboardQueryParams>({
            feedbackStartDate: startDate,
            feedbackEndDate: endDate,
            zoneStartDate: startDate,
            zoneEndDate: endDate,
            revenueStartDate: startDate,
            revenueEndDate: endDate,
            orderStartDate: startDate,
            orderEndDate: endDate,
        })

    const { data, isLoading, isFetching } = useGetDashboardQuery(queryParams)

    const pageData = data?.data

    if (isLoading) {
        return <PageLoader />
    }
    return (
        <main className="content">
            <div className="px-container">
                {!data?.data && !isLoading && !data?.success ? (
                    <h4 className="text-center mt-4">{data?.message}</h4>
                ) : (
                    <div className="row gutters-28">
                        <JobStatistics data={pageData} />
                        <Charts
                            data={pageData}
                            setQueryParams={setQueryParams}
                        />
                    </div>
                )}
            </div>
        </main>
    )
}

export default ExecutivesDashboardPage
